import { render } from "./QuestionGenFloatingWidget.vue?vue&type=template&id=679a2e5c&scoped=true"
import script from "./QuestionGenFloatingWidget.vue?vue&type=script&lang=js"
export * from "./QuestionGenFloatingWidget.vue?vue&type=script&lang=js"

import "./QuestionGenFloatingWidget.vue?vue&type=style&index=0&id=679a2e5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679a2e5c"]])

export default __exports__